//Install
import React, { Component } from "react";
//Install
import { ReactComponent as S310DN } from "../../../Media/Brand/004.svg";

//Element
class B01KQ8 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx r974d2" },
            //Element
            React.createElement(S310DN, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default B01KQ8;